// src/modules/estimateDetails/EstimateDetailService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api'; // Set your base API URL

// Fetch all EstimateDetails
export const getEstimateDetails = async () => {
  try {
    const response = await axios.get(`${API_URL}/estimate-details`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`, // Include authorization token if necessary
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching estimate details:', error);
    throw error;
  }
};
export const getEstimateDetailsById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/estimate-details/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`, // Include authorization token if necessary
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching estimate details:', error);
    throw error;
  }
};

// Create a new EstimateDetail
export const createEstimateDetail = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/estimate-details`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`, // Include authorization token if necessary
      },
    });
    console.log(response);
    return response.data;
  } catch (error) {
    console.error('Error creating estimate detail:', error);
    throw error;
  }
};

// Update an existing EstimateDetail
export const updateEstimateDetail = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL}/estimate-details/${id}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating estimate detail:', error);
    throw error;
  }
};

// Delete an EstimateDetail
export const deleteEstimateDetail = async (id) => {
  try {
    await axios.delete(`${API_URL}/estimate-details/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
  } catch (error) {
    console.error('Error deleting estimate detail:', error);
    throw error;
  }
};
